module.exports = __webpack_public_path__ + "static/media/avatar27.096a81dc.png";